var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70833 0C3.89896 0 0 3.89896 0 8.70833C0 13.5177 3.89896 17.4167 8.70833 17.4167C13.5177 17.4167 17.4167 13.5177 17.4167 8.70833C17.4167 3.89896 13.5177 0 8.70833 0ZM12.483 7.23583C12.5525 7.15638 12.6054 7.06384 12.6386 6.96363C12.6718 6.86343 12.6847 6.7576 12.6764 6.65236C12.6681 6.54713 12.6388 6.44461 12.5903 6.35085C12.5418 6.25709 12.4751 6.17398 12.394 6.1064C12.3129 6.03882 12.2191 5.98814 12.1181 5.95734C12.0172 5.92655 11.911 5.91625 11.806 5.92707C11.701 5.93789 11.5992 5.9696 11.5067 6.02034C11.4141 6.07107 11.3326 6.13981 11.267 6.2225L7.86283 10.3067L6.10138 8.54446C5.95207 8.40025 5.75209 8.32046 5.54452 8.32226C5.33694 8.32406 5.13838 8.40732 4.9916 8.5541C4.84482 8.70088 4.76156 8.89944 4.75976 9.10702C4.75795 9.31459 4.83775 9.51457 4.98196 9.66388L7.35696 12.0389C7.43475 12.1166 7.52788 12.1773 7.63041 12.217C7.73295 12.2568 7.84265 12.2748 7.95251 12.2698C8.06237 12.2648 8.16998 12.237 8.26849 12.1881C8.367 12.1392 8.45425 12.0703 8.52467 11.9858L12.483 7.23583Z",
    fill: "#FF997D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.9e3cdc5d512d3bb7952beabd056ca31f.svg";
export { ForwardRef as ReactComponent };